import * as resourceActionCreators from 'store/actionCreators/resources';

import { resourceSource } from 'sources';
import { ResourceParams } from 'sources/ResourceSource';
import { AppThunk } from 'store/store';
import { setError } from 'store/actions/app';

export const list = (params: ResourceParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const results = await resourceSource.List(params);
    dispatch(resourceActionCreators.listSuccess(results));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};

export const listAll = (params: ResourceParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const results = await resourceSource.ListAll(params);
    dispatch(resourceActionCreators.listAllSuccess(results));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};
